/**
 * Emir Reis — ürün kartı etkileşimleri.
 *
 * 1) "Sepete Ekle" butonu kartın görselindeki beden panelini açar; bedene dokununca
 *    ürün, temanın kendi product-form-component'i üzerinden sepete eklenir
 *    (snippets/emirreis-hizli-ekle.liquid).
 * 2) Renk noktalarının üzerine gelince kart görseli o renge geçer.
 *
 * Kartlar sayfaya sonradan da eklendiği için (sonsuz kaydırma, filtreleme)
 * dinleyiciler belgeye bağlanır.
 */

const SEPET_YAZI = 'Sepete Ekle';
const SECIM_YAZI = 'Beden seçin';

/** @param {Element} kart */
function paneliKapat(kart) {
  kart.removeAttribute('data-er-acik');
  const buton = kart.querySelector('[data-er-sepet]');
  if (!buton) return;
  buton.setAttribute('aria-expanded', 'false');
  buton.textContent = SEPET_YAZI;
}

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  // Beden seçildi: formdaki varyantı ayarla; gönderimi tarayıcı ve tema halleder
  const beden = event.target.closest('[data-er-varyant]');
  if (beden instanceof HTMLButtonElement) {
    const girdi = beden.form?.querySelector('input[name="id"]');
    if (girdi instanceof HTMLInputElement) girdi.value = beden.dataset.erVaryant ?? '';

    beden.dataset.erEklendi = '';
    const kart = beden.closest('product-card');
    setTimeout(() => {
      delete beden.dataset.erEklendi;
      if (kart) paneliKapat(kart);
    }, 1200);
    return;
  }

  // "Sepete Ekle": beden panelini aç / kapat
  const sepet = event.target.closest('[data-er-sepet]');
  if (sepet) {
    const kart = sepet.closest('product-card');
    if (!kart) return;

    const acilacak = !kart.hasAttribute('data-er-acik');
    for (const acik of document.querySelectorAll('product-card[data-er-acik]')) paneliKapat(acik);

    if (acilacak) {
      kart.setAttribute('data-er-acik', '');
      sepet.setAttribute('aria-expanded', 'true');
      sepet.textContent = SECIM_YAZI;
    }
    return;
  }

  // Kartın dışına dokunulursa açık paneli kapat
  if (!event.target.closest('product-card[data-er-acik]')) {
    for (const acik of document.querySelectorAll('product-card[data-er-acik]')) paneliKapat(acik);
  }
});

/**
 * Kartta o an görünen görseli döndürür.
 * @param {Element} kart
 * @returns {HTMLImageElement | null}
 */
function kartGorseli(kart) {
  return kart.querySelector('.card-gallery slideshow-slide:not([aria-hidden="true"]) img') ?? kart.querySelector('.card-gallery img');
}

document.addEventListener('mouseover', (event) => {
  if (!(event.target instanceof Element)) return;
  const nokta = event.target.closest('a.er-renk[data-er-gorsel]');
  const kart = nokta?.closest('product-card');
  if (!(nokta instanceof HTMLElement) || !kart) return;

  const gorsel = kartGorseli(kart);
  if (!gorsel) return;

  if (!gorsel.dataset.erAsil) {
    gorsel.dataset.erAsil = gorsel.currentSrc || gorsel.src;
    gorsel.dataset.erAsilSrcset = gorsel.getAttribute('srcset') ?? '';
  }
  gorsel.removeAttribute('srcset');
  gorsel.src = nokta.dataset.erGorsel ?? gorsel.src;
});

document.addEventListener('mouseout', (event) => {
  if (!(event.target instanceof Element)) return;
  const nokta = event.target.closest('a.er-renk[data-er-gorsel]');
  const kart = nokta?.closest('product-card');
  if (!nokta || !kart) return;

  const gorsel = kart.querySelector('.card-gallery img[data-er-asil]');
  if (!(gorsel instanceof HTMLImageElement)) return;

  if (gorsel.dataset.erAsilSrcset) gorsel.setAttribute('srcset', gorsel.dataset.erAsilSrcset);
  gorsel.src = gorsel.dataset.erAsil ?? gorsel.src;
  delete gorsel.dataset.erAsil;
  delete gorsel.dataset.erAsilSrcset;
});
